// extracted by mini-css-extract-plugin
export default {"wrap":"passwordInput_wrap__IdiZI","input":"passwordInput_input__hODHo","toggle":"passwordInput_toggle__BILYV","lg":"passwordInput_lg__WEHqw"};